import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {type FC, useState} from 'react';
import {useTranslation} from 'react-i18next';
import DialogPanel from '@/components/common/DialogPanel';

//TYPES
type Props = {
  onReupload: (file: File) => void;
  onClose: () => void;
};

const PointCloudReuploadDialog: FC<Props> = ({onReupload, onClose}) => {
  const {t} = useTranslation();

  const [file, setFile] = useState<File>();

  const handleReupload = () => {
    if (file) onReupload(file);
  };

  return (
    <DialogPanel isOpen={true} label={t('pointClouds.title')} onClose={onClose}>
      <Stack direction="column" spacing={2} sx={{maxWidth: '350px', p: 1}}>
        <Typography>{t('pointClouds.reuploadHelperText')}</Typography>
        <Button component="label" variant="outlined" onClick={() => {}}>
          {file?.name || t('pointClouds.file')}
          <input type="file" accept=".laz,.las" onChange={(event) => setFile(event.target.files?.[0])} hidden />
        </Button>
        <Button variant="outlined" disabled={!file} onClick={handleReupload}>
          {t('pointClouds.reupload')}
        </Button>
      </Stack>
    </DialogPanel>
  );
};
export default PointCloudReuploadDialog;
